/* SD v5.4 guarded cart edit restore. The cart ID is stored only in the browser,
 * never placed in a URL. All reads are POST and item-scoped on the backend.
 * Does NOT create a cart, upload original, or write a production order. */
(() => {
  'use strict';
  const KEY='sd_m6_cart_id_v1', PENDING='sd_cart_edit_pending_v1';
  const CART=/^SDC_[A-Za-z0-9_-]{32,96}$/, ITEM=/^SDI_[A-Za-z0-9_-]{24,96}$/;
  const TOKEN=/^[A-Za-z0-9_-]{32,128}$/;
  function cartId(){for (const store of ['localStorage','sessionStorage'])try {
    const value=window[store].getItem(KEY);if(CART.test(value||''))return value;
  }catch(_){}return null;}
  function init(){
    const root=document.querySelector('[data-sd-configurator]');
    if(!root || root.dataset.sdEditRestoreBound) return;
    root.dataset.sdEditRestoreBound='true';
    let pending;
    try { pending=JSON.parse(sessionStorage.getItem(PENDING)||'null'); }catch(_){return;}
    if(!pending||!ITEM.test(pending.item_id||'')||!Number.isFinite(pending.created_at)||
        Date.now()-pending.created_at>15*60*1000) {
      try{sessionStorage.removeItem(PENDING);}catch(_){}return;
    }
    const id=cartId();if(!id)return;
    root.dataset.sdCartEditBlocked='true';
    const configNode=root.querySelector('[data-sd-product-config]');
    let cfg={};try{cfg=JSON.parse(configNode.textContent);}catch(_){return;}
    const api=(root.dataset.apiBase||'').replace(/\/+$/,'')+'/?sd_route=cart/';
    const textNode=root.querySelector('[data-sd-m6-cart-status]');
    function tell(m){if(textNode)textNode.textContent=m;}
    async function post(action,payload,raw=false){
      const response=await fetch(api+action,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload),credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer'});
      if(!response.ok){let msg='Project restoration unavailable.';
        try{const b=await response.json();msg=b.message||msg;}catch(_){}throw Error(msg);}
      if(raw){const blob=await response.blob();if(!['image/png','image/jpeg','image/webp'].includes(blob.type))throw Error('Unsupported editable original image.');return blob;}
      const body=await response.json();if(body.ok!==true)throw Error(body.message||'Could not restore project.');return body;
    }
    let started=false;
    async function restore(){
      if(started)return;started=true;
      root.removeEventListener('sd:quote-ready',restore);
      tell('Restoring your saved design…');
      try{
        const args={cart_id:id,item_id:pending.item_id};
        const data=(await post('edit-context',args)).edit;
        if(data?.item?.pricing_key!==cfg.pricingKey || !TOKEN.test(data.original_token||'') ||
           !TOKEN.test(data.item?.artwork_token||''))throw Error('The saved project does not match this product.');
        if(!data.can_render)throw Error('This file requires production review and cannot be visually edited.');
        const blob=await post('edit-original',args,true);
        if(blob.size>12*1024*1024)throw Error('Image is too large for browser editing.');
        const file=new File([blob],String(data.original_filename||'restored-design.png'),{type:blob.type});
        // v5.4.1: the actual M3 configurator explicitly owns restoration.
        // Wait for its ready method rather than sending a fire-and-forget event.
        // No project mutation occurs unless the live quote confirms restored options.
        const deadline=Date.now()+10000;
        while(typeof root.sdApplySavedCartOptions!=='function' && Date.now()<deadline){
          await new Promise(resolve=>setTimeout(resolve,100));
        }
        if(typeof root.sdApplySavedCartOptions!=='function')
          throw Error('Configurator restore interface is unavailable. Refresh this page.');
        root.sdApplySavedCartOptions(data.item);
        // Let the authoritative M3 quote load for the restored settings.
        const priceReady=new Promise((resolve,reject)=>{
          const timer=setTimeout(()=>reject(Error('Live price unavailable for restored project.')),12000);
          const success=e=>{const c=e.detail?.configuration || {};
            if(c.pricing_key===data.item.pricing_key &&
               Number(c.quantity)===Number(data.item.sticker_quantity) &&
               Number(c.width)===Number(data.item.width) &&
               Number(c.height)===Number(data.item.height) &&
               c.shape===data.item.shape && c.cut_style===data.item.cut_style &&
               c.finish===data.item.finish && e.detail?.quote?.status==='priced'){
               clearTimeout(timer);root.removeEventListener('sd:quote-ready',success);resolve(true);}};
          root.addEventListener('sd:quote-ready',success);
        });
        await priceReady;
        root.dispatchEvent(new CustomEvent('sd:cart-edit-restore-artwork',{bubbles:true,detail:{
          file,active_token:data.item.artwork_token,original_token:data.original_token,spec:data.edit_spec}}));
        root.dataset.sdCartEditBlocked='false';
        root.dataset.sdCartEditItem=data.item.item_id;
        root.dataset.sdCartEditVersion=String(data.cart_version);
        root.dispatchEvent(new CustomEvent('sd:cart-edit-mode',{bubbles:true}));
        root.dispatchEvent(new CustomEvent('sd:artwork-uploaded',{bubbles:true,detail:{derived:true,info:{token:data.item.artwork_token}}}));
        tell('Project restored. Changes will update this item, without creating another.');
      }catch(error){
        tell('Could not open this design: '+(error?.message||'Unexpected error')+'. Return to Your Cart and retry.');
        try{sessionStorage.removeItem(PENDING);}catch(_){}
      }
    }
    // Metadata and event listeners are ready once the product has its first quote.
    root.addEventListener('sd:quote-ready',restore);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();